import React from "react"

import { Grid2X2, Kanban, Table } from "lucide-react"

import Icon from "@/components/Icon"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

type ViewMode = "grid" | "table" | "kanban" | "calendar"

interface ViewToggleProps {
  viewMode: ViewMode
  setViewMode: (mode: ViewMode) => void
  toggleType: "applications" | "trial" | "grid-table"
}

const ViewToggle = ({ viewMode, setViewMode, toggleType }: ViewToggleProps) => {
  const renderToggleItems = () => {
    switch (toggleType) {
      case "applications":
        return (
          <>
            <TabsTrigger value="kanban">
              <Kanban size={16} className="mr-2" />
              Kanban
            </TabsTrigger>
            <TabsTrigger value="table">
              <Table size={16} className="mr-2" />
              Table
            </TabsTrigger>
          </>
        )
      case "trial":
        return (
          <>
            <TabsTrigger value="calendar">
              <Icon name="calendarBlank" className="h-4 w-4 mr-2 text-inherit" />
              Calendar
            </TabsTrigger>
            <TabsTrigger value="table">
              <Table size={16} className="mr-2" />
              Table
            </TabsTrigger>
          </>
        )
      case "grid-table":
        return (
          <>
            <TabsTrigger value="grid">
              <Grid2X2 size={16} className="mr-2" />
              Grid
            </TabsTrigger>
            <TabsTrigger value="table">
              <Table size={16} className="mr-2" />
              Table
            </TabsTrigger>
          </>
        )
    }
  }

  return (
    <Tabs value={viewMode} onValueChange={(v) => setViewMode(v as ViewMode)}>
      <TabsList>{renderToggleItems()}</TabsList>
    </Tabs>
  )
}

export default ViewToggle
